/* istanbul ignore file */
import React from 'react';
import { InputList, InputListProps } from 'framework/form';
import { Box } from '@mui/material';

const FamilyMemberListInput: React.FC<InputListProps> = ({ inputTemplate, ...props }) => {
  return (
    <Box
      sx={theme => ({
        [theme.breakpoints.up('sm')]: {
          marginTop: '-10px',
          marginBottom: '5px',
        },
      })}
    >
      <InputList {...props} inputTemplate={inputTemplate} />
    </Box>
  );
};

export default FamilyMemberListInput;
